module.exports = __webpack_public_path__ + "img/icon-email.21259236.svg";